<template>
  <div class="page-with-top-bar">
    <project-template-admin-quick-buttons hiddenOption="activity-groups"/>
    <section>
      <div class="mt-4">
        <b-tabs type="is-boxed" v-model="mainActiveTab">
          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="layer-group"></b-icon>
              <span> {{ $t('activity_groups') }} </span>
            </template>
            <div>
              <manage-groups-activities
                :projectId="projectId"
                :entityType="'project-template'"
              ></manage-groups-activities>
            </div>
          </b-tab-item>

        </b-tabs>
      </div>
    </section>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import ProjectTemplateAdminQuickButtons from '../../../components/project-template-admin-quick-buttons.vue'
  import ManageGroupsActivities from '../../../components/activity-groups/manage-groups-activities.vue'

  export default {
    middleware: 'auth',
    title: 'manage_statuses_page_title',
    menuOption: '0-6',

    components: {
      ManageGroupsActivities,
      ProjectTemplateAdminQuickButtons
    },

    data: () => ({
      mainActiveTab: 0,
    }),

    computed: {
      ...mapGetters({
        project: "template/project"
      }),

      projectId() {
        return parseInt(this.$route.params.template_id);
      }

    },

    watch: {
      mainActiveTab(value) {
        if (value == 0) {
          this.$refs.project_locations_manual.reload()
        }
      }
    },

    created() {
      let projectName = this.project.name
        ? this.project.name.toUpperCase()
        : "";
      this.$options.subtitle = ["project_actions_page_subtitle", [projectName]];
    },

    methods: {}
  };
</script>
